module.exports = __webpack_public_path__ + "static/img/step-1022.ec07f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1022.png
// module id = H+3I
// module chunks = 1